import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c388e1c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "user-code-wraper cola-color font-Pretendar text-center d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fw-bold text-80 text-20" }, [
  /*#__PURE__*/_createTextVNode(" 추가 제로 웨이스 박스는 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1세트 당 N개씩 발송해드려요! ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-5 text-14 text-54" }, " 필요한 박스의 수만큼 신청해주세요 ", -1))
const _hoisted_4 = { class: "form-container" }
const _hoisted_5 = { class: "select-wrapper" }
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label text-54 text-18" }, "세트", -1))
const _hoisted_8 = { class: "select-wrapper" }
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label text-54 text-18" }, "개", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cola-color font-Pretendar" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mt-5 fw-bold text-20 text-80" }, " 박스 추가 신청 완료 "),
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-3 text-14 text-54" }, [
    /*#__PURE__*/_createTextVNode(" 2~3일 내 회원가입 시 입력한 주소로 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 제로 웨이스트 박스가 발송합니다. ")
  ])
], -1))

import ColaButton from '@/templates/campaign-cocacola-season-6/components/cola-button.vue';
import { ref } from 'vue';
import ParticipateSuccess from '@/templates/campaign-cocacola-season-6/components/participate-success.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const activeStep = ref(1);

const numbers = Array.from({ length: 10 }, (_, i) => i + 1);
const numbers5 = Array.from({ length: 5 }, (_, i) => i + 1);

const handleSubmit = () => {
  activeStep.value = 2;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (activeStep.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.setValue) = $event)),
                  class: "custom-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numbers5), (n) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: n,
                      value: n
                    }, _toDisplayString(n), 9, _hoisted_6))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.setValue]
                ]),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemValue) = $event)),
                  class: "custom-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numbers), (n) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: n,
                      value: n
                    }, _toDisplayString(n), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.itemValue]
                ]),
                _hoisted_10
              ])
            ])
          ]),
          _createVNode(ColaButton, {
            title: "박스 추가 신청하기",
            class: "mt-5 d-none d-sm-block",
            type: "button",
            border: true,
            onClick: handleSubmit
          }),
          _createVNode(ColaButton, {
            title: "박스 추가 신청하기",
            class: "mt-5 d-sm-none",
            type: "button",
            border: true,
            responsive: "",
            onClick: handleSubmit
          })
        ]))
      : _createCommentVNode("", true),
    (activeStep.value == 2)
      ? (_openBlock(), _createBlock(ParticipateSuccess, { key: 1 }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})